import React from 'react';
import PropTypes from 'prop-types';

import {
    CustomHeadCellContainer,
    PlayerWrapper
} from '../LineupMatchup.style';

const CustomHeadCell = ({
    content = []
}) => {
    const team = content?.[0] || '';
    const player = content?.[1] || '';
    return (
        <CustomHeadCellContainer>
         <div>{team}</div><span>{team && player ? 'vs.' : ''}</span> <PlayerWrapper>{player}</PlayerWrapper>
        </CustomHeadCellContainer>
    );
};

CustomHeadCell.propTypes = {
    data: PropTypes.object
};

export default CustomHeadCell;
